import { useContext } from 'react';

import { NotificationDialogContext } from '../components/context/NotificationDialogContext';

function useNotificationDialogContext() {
  return useContext(NotificationDialogContext);
}

export default useNotificationDialogContext;
